export default __webpack_public_path__ + "static/media/Shopping-Cart.fa8067e9.jpg";